export const DEFAULT_PAGINATION_SIZE = 20;
export const DEFAULT_OFFSET = 0;

export const getPaginationOffset = (
  currentPage: number,
  pageSize: number = DEFAULT_PAGINATION_SIZE
) => {
  if (currentPage === 1) return 0;

  if (currentPage > 1) {
    const offset = (currentPage - 1) * pageSize;
    return offset;
  }

  return 0;
};

export const usePaginationOffset = getPaginationOffset;
